import React from "react";
import styled from "styled-components";
import Contact from "../../components/Contact/Contact";

const ContactPageContainer = styled.div`
  min-height: 100vh;
  padding-top: 90px; /* Add padding to push contact card down below navigation */
  background: #fff /* Match your site's background */
  
  @media (max-width: 768px) {
    padding-top: 100px; /* Less padding on mobile */
  }
`;

export default function ContactUs() {
  return (
    <ContactPageContainer>
      <Contact expanded={true} />
    </ContactPageContainer>
  );
}